import { useFetch, useIsLoading } from "../../Hooks/useFetch";
import EntitySection from "../../Components/Shared/EntitySection/EntitySection";
import {
  expirationColumn,
  idColumn,
  nameColumn,
  textColumn,
  yesNoColumn,
} from "../../Components/Shared/TableColumns/tableColumns";
import { getAllCertificates, deleteCertificate } from "../../Service/InventoryService/InventoryService";
import CertificateDetail from "./CertificateDetail";
import { distinctFilter, expirationFilter, yesNoFilter } from "../../Components/Shared/TableFilters/filterDefs";

export const Certificates = () => {
  const [certificates, isFetchingCertificates, updateCertificates] = useFetch(getAllCertificates);
  const isLoading = useIsLoading([isFetchingCertificates]);

  const columns = [
    idColumn(),
    nameColumn("url", "URL"),
    expirationColumn(),
    textColumn("type", "Tipo de certificado"),
    textColumn("hosting", "Hosting"),
    yesNoColumn("auto_re", "Autorenovación"),
  ];

  const filters = [
    distinctFilter("type", "Tipo de certificado", certificates, "type"),
    distinctFilter("hosting", "Hosting", certificates, "hosting"),
    yesNoFilter("auto_re", "Autorenovación", "auto_re"),
    expirationFilter(),
  ];

  return (
    <EntitySection
      filters={filters}
      title="Certificados"
      addLabel="Añadir certificado"
      type="certificado"
      rows={certificates}
      loading={isLoading}
      columns={columns}
      onDelete={(row) => deleteCertificate(row.id)}
      onChanged={updateCertificates}
      detailTitle="Información del Certificado"
      renderDetail={(row) => <CertificateDetail row={row} />}
    />
  );
};
